import { ProjectService } from '@alpha-core/platform-ui';
import { Component, inject } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToolbarModule } from 'primeng/toolbar';
import { Subscription } from 'rxjs';
import { ImageDisplayDirective } from '../../../pipes/image-display.directive';
import { LanguagesComponent } from '../languages/languages.component';
import { UserComponent } from '../user/user.component';

@Component({
    selector: 'app-toolbar',
    standalone: true,
    imports: [
        InputTextModule,
        SplitButtonModule,
        ButtonModule,
        AvatarModule,
        ToolbarModule,
        UserComponent,
        LanguagesComponent,
        ImageDisplayDirective,
    ],
    templateUrl: './toolbar.component.html',
})
export class ToolbarComponent {
    projectService = inject(ProjectService);

    defaultLogoUrl = 'assets/images/NeutrinosLogo.svg';
    logoUrl: any;
    subscription!: Subscription;

    ngOnInit() {
        this.subscription = this.projectService.fetchLogo().subscribe((logo) => {
            this.logoUrl = logo;
        });
    }

    ngOnDestroy() {
        this.subscription && this.subscription.unsubscribe();
    }
}
